/*
 * 电表 — 画布上用矢量图形表示，不依赖 meter.png
 */
import Konva from 'konva'
import { GraphElement } from '../graph-element.js'
import { createFromJSON } from './help.js'

class MeterElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, 'meter', x, y, {
      text: '电表',
      port: true,
      ...attrs,
    })

    this.onLoad(() => {
      this.prop_y = -8
      this.addProperty('功率', 'kW')
      this.addProperty('电压', 'V')
      this.addProperty('电流', 'A')
      this.addProperty('功率因数', '')
    })
  }

  updateData(data) {
    this.updateProperty('功率', data.p_total)
    this.updateProperty('电压', data.u_a)
    this.updateProperty('电流', data.i_a)
    this.updateProperty('功率因数', data.pf)
  }

  addKeyShape(name, attrs) {
    const w = 44
    const h = 52
    const g = new Konva.Group({
      x: 0,
      y: 0,
      width: w,
      height: h,
      isKeyShape: true,
      name: `${name}-img`,
    })

    g.add(
      new Konva.Rect({
        x: 0,
        y: 0,
        width: w,
        height: h,
        cornerRadius: 6,
        fillLinearGradientStartPoint: { x: 0, y: 0 },
        fillLinearGradientEndPoint: { x: w, y: h },
        fillLinearGradientColorStops: [0, '#5B8CFF', 1, '#2F59EB'],
        stroke: '#1a3d99',
        strokeWidth: 1,
      }),
    )
    g.add(
      new Konva.Rect({
        x: 8,
        y: 10,
        width: w - 16,
        height: 18,
        cornerRadius: 2,
        fill: '#0d1b3a',
        opacity: 0.92,
      }),
    )
    g.add(
      new Konva.Line({
        points: [12, 16, w - 12, 16, w - 12, 22, 12, 22],
        stroke: '#7ecbff',
        strokeWidth: 1,
        opacity: 0.85,
      }),
    )
    g.add(
      new Konva.Rect({
        x: w / 2 - 10,
        y: 34,
        width: 20,
        height: 10,
        cornerRadius: 2,
        fill: '#FEB44A',
        stroke: '#c98a2c',
        strokeWidth: 0.5,
      }),
    )

    this.keyShape = g
    this.g.add(g)
    setTimeout(() => this.executeLoadedHook(this.keyShape), 0)
  }

  get width() {
    return 44
  }

  get height() {
    return 52
  }
}

export { MeterElement }
